import { useCallback, useRef, useState } from 'react';

const useInViewport = (): [React.RefCallback<HTMLDivElement>, boolean] => {
  const [isInViewport, setIsInViewport] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const ref = useCallback((element: HTMLDivElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (!element) return;

    observerRef.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInViewport(true);
        observerRef.current?.disconnect();
      }
    });

    observerRef.current.observe(element);
  }, []);

  return [ref, isInViewport];
};

export default useInViewport;
